import { FC } from 'react'
import ConsumerFooter from './ConsumerFooter'
import PromoBanner from './PromoBanner'
import Header from './Header'

interface PagePropsInterface {
    content?: object
    consumerBanner?: any
    corporateBanner?: any
}

interface GlobalLayout {
    Component: Function // This is a Page, which is a React Functional Component. May want to make this interface be more specific here.
    pageProps: PagePropsInterface
    isCorporate: boolean
}

const GlobalLayout: FC<GlobalLayout> = ({
    Component,
    pageProps,
    isCorporate,
}) => {
    const promoBannerHtml = isCorporate
        ? pageProps?.corporateBanner?.data?.content
        : pageProps?.consumerBanner?.data?.content

    return (
        <>
            <PromoBanner
                promoBannerHtml={promoBannerHtml}
                isCorporate={isCorporate}
            />
            <Header isCorporate={isCorporate} />
            <main>
                <Component {...pageProps} />
            </main>
            <ConsumerFooter />
        </>
    )
}

export default GlobalLayout
